import { Backdrop } from "@mui/material";
import React, { useState } from "react";
import useStyles from "./loader_styles";
import { Hypnosis } from "react-cssfx-loading";

export default function Loader() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  global.setLoading = (val) => {
    setOpen(val);
  };
  return (
    <Backdrop className={classes.backdrop} open={open}>
      <div className={classes.loader_outer}>
        {/* <RingLoader size={100} color="white" /> */}
        <Hypnosis color="#fbaf41" width="50px" height="50px" duration="3s" />
      </div>
    </Backdrop>
  );
}
